import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

const HIDE_KLARNA_ON_PDP = 'hideKlarnaOnPDP';

export const isHideKlarnaOnPDPTestVariant = (): boolean =>
    getAbTestV2(HIDE_KLARNA_ON_PDP)?.variant === 'variant';

export const trackHideKlarnaOnPDPTestVariant = (): void => {
    trackAbTestV2Variant(HIDE_KLARNA_ON_PDP);
};
